import { useEffect, useRef, useState } from "react";
import { FaShippingFast } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { autoCompleteDelay } from "../../config";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FetchAutoCompleteData, FindTranslatedKey, handleDateChange } from "../CommonComponents/CustomHooks";
import { AutoCompleteBox, DateBox, FormButton, InputBox, TimeBox } from "../CommonComponents/InputBox";

const ProgressUpdate = () => {
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const selectedDate = new Date();
    const dateArr2 = selectedDate.toDateString().split(" ");
    const formattedDate = `${dateArr2[2]}-${dateArr2[1]}-${dateArr2[3]}`;
    const [anotherTableData, setAnotherTableData] = useState({})
    const now = new Date();
    const formattedTime = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;

    const [formData, setFormData] = useState({
        "progressID": "0",
        "progressDate": formattedDate,
        "progressTime": formattedTime ? formattedTime : '',
        "awbNo": "",
        "exception": ""
    })

    const handleClear = () => {
        setFormData({
            "progressID": "0",
            "progressDate": formattedDate,
            "progressTime": formattedTime ? formattedTime:'',
            "awbNo": "",
            "exception": ""
        });
        setAnotherTableData({})
    };

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Operation/ProgressUpdate', formData)
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
       

    }
    const GetData = async () => {
        setLoading(true)
        let data = await ApiCall('/api/Operation/GetProgressDetails', formData)
        setLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
        setAnotherTableData(data)
        setLoading(false)
    }
    const autoCompleteTimeoutRef = useRef(null);
    const handleAutoCompleteChange = async (event, newValue, field, type) => {
        if (autoCompleteTimeoutRef.current) {
            clearTimeout(autoCompleteTimeoutRef.current);
        }
        if (event?.type === 'change') {
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData('', newValue, type, field);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay)
        }
    };
    useEffect(() => {
        document.title = 'Progress Update'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> {FindTranslatedKey('Progress Update')}</h6>
                </div>
                <div className='card-body row'>
                    <div className='row'>
                        <DateBox
                            inputrefs={inputrefs}
                            label="Progress Date"
                            placeholder="Progress Date"
                            id='txtProgressDate'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtProgressTime'].focus()
                                };
                            }}
                            required={true}
                            selected={formData.progressDate === '' ? '' : new Date(formData.progressDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'progressDate')}
                        />
                        <TimeBox
                            inputrefs={inputrefs}
                            PlaceHolderText='Progress Time'
                            label='Progress Time'
                            type='time'
                            id='txtProgressTime'
                            value={formData.progressTime ? formData.progressTime : ''}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtAwbNo'].focus()
                                };
                            }}
                            onChange={(e) => setFormData({ ...formData, progressTime: e ? e : '' })}
                        />
                        <InputBox
                            id="txtAwbNo"
                            PlaceHolderText="AWB No./Reference No."
                            maxLength='25'
                            required={true}
                            label='AWB No./Reference No.'
                            value={formData.awbNo}
                            onChange={(e) => {
                                setFormData({ ...formData, awbNo: e.target.value })
                            }}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtException'].focus()
                                    GetData(formData.awbNo)
                                }
                            }}
                        />
                        <AutoCompleteBox
                            label='Exception'
                            placeholder='Exception'
                            inputValue={formData.exception ? formData.exception : ''}
                            onInputChange={
                                (event, newInputValue) => {
                                    handleAutoCompleteChange(event, newInputValue, '', 'GetExceptionData');
                                    setFormData({ ...formData, exception: newInputValue })
                                }}
                            maxLength='50'
                            options={autoCompleteOptions}
                            setOptions={setAutoCompleteOptions}
                            inputrefs={inputrefs}
                            id='txtException'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['btnSave'].focus() };
                            }}
                            required
                        />
                    </div>
                    <div className='col-md-2 mt-3'>
                        <FormButton
                            id='btnSave'
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            handleClear={handleClear}
                            Export={false}
                        />
                    </div>
                </div>
            </div>


            {anotherTableData?.shipmentDetail &&
                <div className='main-card card border-0 mb-2' style={{ borderTop: "2px solid #f18282" }}>
                    <div className='d-flex justify-content-between'>
                        <h5 className='m-1 p-2 awbgradient' > {FindTranslatedKey('Shipment Detail')} <FaShippingFast className='text-success' /></h5>
                        <h5 className='m-1 p-2 awbgradient' > {FindTranslatedKey('Customer Ref No:')} {anotherTableData.shipmentDetail.customerRefNo}</h5>

                    </div>

                    {/* Filter and Advance Filter Icon and paging*/}
                    <div className='card-header mb-1'>
                        <div className='row justify-content-between align-items-center'>
                            <div className='col-md-4'>

                            </div>
                            <div className='card-body'>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped mb-0">
                                        <tbody style={{ fontSize: '13px', padding: '1px' }}>
                                            <tr >
                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hReferenceNo)}  </td>
                                                <td >{anotherTableData.shipmentDetail.referenceNo} </td>
                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hAwbNo)}  </td>
                                                <td colspan='3' >{anotherTableData.shipmentDetail.awbNo} </td>
                                            </tr>






                                            <tr>
                                                <td className='fw-bold awbgrid ' > {FindTranslatedKey(anotherTableData.shipmentDetail.hBookingDate)}  </td>
                                                <td >  {anotherTableData.shipmentDetail.bookingDate} </td>

                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hWeight)}  </td>
                                                <td colspan='3'>  {anotherTableData.shipmentDetail.weight} </td>
                                            </tr>






                                            <tr>
                                                <td className='fw-bold awbgrid'> {FindTranslatedKey(anotherTableData.shipmentDetail.hVolWeight)}  </td>
                                                <td>  {anotherTableData.shipmentDetail.volWeight} </td>
                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hValue)}  </td>
                                                <td>  {anotherTableData.shipmentDetail.totalValue} </td>
                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hpcs)}   </td>
                                                <td >  {anotherTableData.shipmentDetail.quantity}</td>
                                            </tr>






                                            <tr>

                                                <td className='fw-bold awbgrid' >
                                                    {FindTranslatedKey(anotherTableData.shipmentDetail.hConsignor)}  </td>
                                                <td >
                                                    <span className='text-center fw-bolder'>
                                                        {anotherTableData.shipmentDetail.consignor}</span> <br />
                                                    <span className='fw-bold'></span>
                                                    {anotherTableData.shipmentDetail.consignorAddress1} ,
                                                    {anotherTableData.shipmentDetail.consignorAddress2} ,
                                                    {anotherTableData.shipmentDetail.consignorAddress3}  <br />
                                                    <span className='fw-bold'></span>
                                                    {anotherTableData.shipmentDetail.consignorCountry} ,
                                                    {anotherTableData.shipmentDetail.consignorState} ,
                                                    {anotherTableData.shipmentDetail.consignorCity} ,
                                                    {anotherTableData.shipmentDetail.consignorZip} <br />
                                                    <span className='fw-bold'></span>
                                                    {anotherTableData.shipmentDetail.consignorPhoneNo}

                                                </td>

                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hConsignee)}  </td>
                                                <td colspan='3'>
                                                    <span className='text-center fw-bolder'>
                                                        {anotherTableData.shipmentDetail.consignee}
                                                    </span>  <br />
                                                    <span className='fw-bold'></span>
                                                    {anotherTableData.shipmentDetail.consigneeAddress1} ,
                                                    {anotherTableData.shipmentDetail.consigneeAddress2}
                                                    , {anotherTableData.shipmentDetail.consigneeAddress3}  <br />
                                                    <span className='fw-bold'></span>
                                                    {anotherTableData.shipmentDetail.consigneeCountry} ,
                                                    {anotherTableData.shipmentDetail.consigneeState} ,
                                                    {anotherTableData.shipmentDetail.consigneeCity} ,
                                                    {anotherTableData.shipmentDetail.consigneeZip}   <br />
                                                    <span className='fw-bold'></span>
                                                    {anotherTableData.shipmentDetail.consigneePhoneNo}
                                                </td>

                                            </tr>








                                            <tr>
                                                <td className='fw-bold awbgrid'> {FindTranslatedKey(anotherTableData.shipmentDetail.hConsigneeCity)}  </td>
                                                <td >  {anotherTableData.shipmentDetail.consigneeCity} </td>
                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hPacketStatus)}  </td>
                                                <td colspan='3'> {anotherTableData.shipmentDetail.packetStatus}</td>
                                            </tr>









                                            <tr>
                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hPacketType)}  </td>
                                                <td >  {anotherTableData.shipmentDetail.packetType} </td>
                                                <td className='fw-bold awbgrid' >{FindTranslatedKey(anotherTableData.shipmentDetail.hPaymentType)}</td>
                                                <td colspan='3'>{anotherTableData.shipmentDetail.paymentType}</td>
                                            </tr>











                                            <tr>
                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hForwordingParty)}   </td>

                                                <td >  {anotherTableData.shipmentDetail.forwordingParty}</td>
                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hForwordingNo)}  </td>
                                                <td colspan='3'> {anotherTableData.shipmentDetail.forwordingNo} </td>
                                            </tr>

                                            <tr>

                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            }



        </>
    )
}

export default ProgressUpdate;